module.exports = __webpack_public_path__ + "static/media/silverware-fork-knife.d82040d2.png";